import { __read, __spreadArray } from "tslib";
import * as actionTypes from '../constants/actionTypes';
export var initialState = [];
export default function hoverStack(state, action) {
    if (state === void 0) { state = initialState; }
    switch (action.type) {
        case actionTypes.ADD_TO_HOVER_STACK:
            return __spreadArray(__spreadArray([], __read(state), false), [action.hoverOutInfo], false);
        case actionTypes.REMOVE_FROM_HOVER_STACK:
            return state.slice(0, -action.numberOfLevels);
        case actionTypes.SHOW_SCREEN:
        case actionTypes.SHOW_OVERLAY:
        case actionTypes.HIDE_OVERLAY:
            return initialState;
        default:
            return state;
    }
}
